import { createActionGroup, props } from '@ngrx/store';
import { PaginableUsersHttpResult } from '../../models/users.model';

export const FollowersAction = createActionGroup({
  source: 'Followers',
  events: {
    'Get Followers': props<{userId?: number|string, page: number, forceReload?: boolean}>(),
    'Followers loaded': props<{userId: number|string, page: number, pageSize: number, body: PaginableUsersHttpResult}>(),
    'Get Followings': props<{userId?: number|string, page: number, forceReload?: boolean}>(),
    'Followings loaded': props<{userId: number|string, page: number, pageSize: number, body: PaginableUsersHttpResult}>(),
    Clear: props<{userId?: number|string}>()
  }
});
